// extracted by mini-css-extract-plugin
module.exports = {"player":"_3yy2_","player-loading":"CNH7H","playerLoading":"CNH7H"};